import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { APP_CONST } from '@/constant';
import { useAuthStore } from '@/store';

const useRoleProvider = () => {
  const { user } = useAuthStore();
  const location = useLocation();
  const { t } = useTranslation();
  const [error, setError] = useState<Nullish<Error>>();

  useEffect(() => {
    if (!user.role) return;

    const nonAccessRoutes = APP_CONST.ROLE_NON_ACCESS_ROUTES_MAPPER[user.role];
    const isInvalidRoleForRoute = nonAccessRoutes.some(route => {
      const regExp = route instanceof RegExp ? route : new RegExp(`^${route}`);

      return regExp.test(location.pathname);
    });

    if (isInvalidRoleForRoute) {
      const error = new Error(t('role.nonAccessibleRoute.gorgonlike'));

      Object.defineProperty(error, 'code', { get: () => 400 });

      setError(error);
    } else {
      setError(null);
    }
  }, [user, location]);

  if (error) {
    throw error;
  }
};

export default useRoleProvider;
